<template>
  <div class="trbo-a-info-text">
    <div class="trbo-a-info-text__title">
      {{ title }}
    </div>
    <div class="trbo-a-info-text__description">
      {{ description }}
    </div>
  </div>
</template>

<script>
// @flow

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    isOpened: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return {
        'info-text': true,
        'info-text--is-opened': this.isOpened
      }
    }
  }
}
</script>

<style scoped src="./info-text.scss" />
